import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { footerAll } from "./Footer2";
// import { useAuth } from "../context/auth";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Footer3 = () => {
  const { selectedLanguage } = useContext(LanguageContext);
  // const [auth] = useAuth();
  return (
    <>
      <div
        className="foterh py-10"
        style={{ backgroundColor: "#F0F0F0",  }}
      >
        <div className="d-flex mx-sm-5 mx-3  justify-content-between">
          <div className="d-flex  justify-content-center gap-md-4 mt-md-2 p-md-4  padtopfoter2">
            <Link
              to="/terms"
              className="text-decoration-none fw-normal fontmobil"
              style={{
                color: "#666666",

                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {footerAll[selectedLanguage]?.termText || "Terms of use"}
            </Link>
            <Link
              to="/privacy"
              className="text-decoration-none fw-normal fontmobil"
              style={{
                color: "#666666",

                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {footerAll[selectedLanguage]?.privacyText || "Privacy"}
            </Link>
            <Link
              to="/cookies"
              className="text-decoration-none fw-normal fontmobil"
              style={{
                color: "#666666",

                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {footerAll[selectedLanguage]?.cookiesText || "Cookies"}
            </Link>

            <Link
              to="/help"
              className="text-decoration-none  fw-normal fontmobil"
              style={{
                color: "#666666",
                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {footerAll[selectedLanguage]?.helpText || "Help"}
            </Link>

            {/* <div>
              {auth?.user ? (
                <Link
                  to="/help"
                  className="text-decoration-none  fw-bold fontmobil"
                  style={{
                    color: "#666666",
                    lineHeight: "24.51px",
                    fontSize: "18px",
                  }}
                >
                  Help
                </Link>
              ) : (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-login">Please login first</Tooltip>
                  }
                >
                  <span
                    className="text-decoration-none  fw-bold fontmobil"
                    style={{
                      color: "#666666",
                      lineHeight: "24.51px",
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                  >
                    Help
                  </span>
                </OverlayTrigger>
              )}
            </div> */}
          </div>

          <div className="mt-md-4 mt-4  mx-md-5 ">
            <div
              className="fw-bold text-center mt-md-1 ftzcopy"
              style={{
                lineHeight: "35.85px",
                fontSize: "16px",
                color: "#666666",
              }}
            >
              {footerAll[selectedLanguage]?.followText || "Follow us"}
            </div>
            <div className="d-flex justify-content-center gap-md-3 gap-1 mt-md-1 ">
              <a
                href="https://www.facebook.com/profile.php?id=61582380255125"
                target="blank"
              >
                <img
                  src={require("./image/fbfooterag.png")}
                  width="32"
                  height="32"
                  style={{ cursor: "pointer" }}
                />
              </a>
              <a href="https://www.tiktok.com/@ofellio" target="blank">
                <img
                  src={require("./image/tiktokagffoter.png")}
                  style={{ cursor: "pointer" }}
                  width="32"
                  height="32"
                />
              </a>
              <a
                href="https://www.instagram.com/ofellio_official/"
                target="blank"
              >
                <img
                  src={require("./image/insatfooterag.png")}
                  style={{ cursor: "pointer" }}
                  width="32"
                  height="32"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer3;
